import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';
import { Command as CommandPrimitive } from 'cmdk';

export type CommandEmptyProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Empty>;

const CommandEmpty = forwardRef<ElementRef<typeof CommandPrimitive.Empty>, CommandEmptyProps>(
  (props, ref) => (
    <CommandPrimitive.Empty ref={ref} className="py-6 text-center text-sm" {...props} />
  )
);

CommandEmpty.displayName = CommandPrimitive.Empty.displayName;

export default CommandEmpty;
